import { createAction, props } from "@ngrx/store";
import { AnimalResponse } from "../../models/branding.interface";

export const LOAD_PETS = 'Load Pets';
export const LIST_OF_PETS = 'Get List Of Pets';
export const LIST_OF_PETS_ERROR = 'List Of Pets Error';
export const LIST_OF_PETS_SUCCESS = 'List Of Pets Success';
export const UPDATE_PET_INFO = 'Update Pet Info';
export const RESET_PETS = 'Reset Pets';

export const resetPets = createAction(RESET_PETS);
export const loadPets = createAction(LOAD_PETS);
export const getPets = createAction(LIST_OF_PETS, props<{ pets: any[] }>());
export const getPetsError = createAction(LIST_OF_PETS_ERROR,
  props<{ errorCode: string, errorMessage: string }>());
export const getPetsSuccess = createAction(LIST_OF_PETS_SUCCESS);
export const updatePetInfo = createAction(UPDATE_PET_INFO, props<{ pet: AnimalResponse }>());
